interface InviteTextInputProps {
  value: string;
  onChange: (value: string) => void;
  'aria-label': string;
}

/** Plain text input styled for the invite drawer's name fields. */
export default function InviteTextInput({
  value,
  onChange,
  'aria-label': ariaLabel,
}: InviteTextInputProps) {
  return (
    <input
      value={value}
      aria-label={ariaLabel}
      onChange={(e) => onChange(e.target.value)}
      className="w-full h-9 px-2.5 rounded-lg border border-stone-200 dark:border-stone-800 bg-white dark:bg-[#1a1f1c] text-[13px] text-bark-900 dark:text-[#e8ece9] outline-none focus:ring-2 focus:ring-moss-500 focus:ring-offset-1"
    />
  );
}
